import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface UserRow {
  id: string;
  email: string;
  nickname: string | null;
  tier_id: string;
  created_at: string;
}

export function useAdminUserSearch(term: string) {
  const [debouncedTerm, setDebouncedTerm] = useState(term);

  useEffect(() => {
    const t = setTimeout(() => setDebouncedTerm(term), 250);
    return () => clearTimeout(t);
  }, [term]);

  const query = useQuery({
    queryKey: ["admin-user-search", debouncedTerm],
    enabled: debouncedTerm.length >= 2,
    queryFn: async () => {
      const { data, error } = await supabase.rpc("admin_search_users", {
        term: debouncedTerm,
      });
      if (error) throw error;
      return (data as UserRow[]) ?? [];
    },
    staleTime: 30_000,
  });

  return {
    data: debouncedTerm.length < 2 ? [] : (query.data ?? []),
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
